import React from 'react';

import packageJson from '../../../package.json';
import { cfPath } from '../../utilities/UrlPaths';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { name, releaseDate, version } = packageJson;
  const siteName = (window.location.hostname.indexOf('auctionzipauctions') > -1) ? 'AuctionZip.com' : 'Invaluable.com';
  const termsLink = (window.location.hostname.indexOf('auctionzipauctions') > -1) ? 'https://www.auctionzip.com/agreements/terms.html' : 'https://www.invaluable.com/inv/agreements/terms-of-use/';
  const privacyLink = (window.location.hostname.indexOf('auctionzipauctions') > -1) ? 'https://www.auctionzip.com/agreements/privacy.html' : 'https://www.invaluable.com/inv/agreements/privacy-policy/';

  return (
    <footer className="footer-container">
      <div className="container pt-1">
        <div className="footer-content mx-auto my-4 pt-3">
          Copyright © 1986-
          {currentYear} Invaluable, LLC. and participating Sellers. All Rights
          Reserved. Use of this website is subject to the{' '}
          <a
            href={`${termsLink}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {siteName}{' '}Terms of Use
          </a>
          {' '}and other terms agreed to in writing by each Seller and Invaluable,
          LLC. You may not use the password protected services of this website
          if you have not entered into a{' '}
          <a
            href={`${cfPath()}/MSA_8_2018.pdf`}
            target="_blank"
            rel="noopener noreferrer"
          >
            written contract with Invaluable
          </a>
          {' '}that allows you access.
          <div className="mt-3">
            <a href={`${cfPath()}/inv/help-center/contact-us/`}>Contact Us</a>
            <span> | </span>
            <a
              href={`${privacyLink}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy
            </a>
          </div>
          <div className="mt-1">
            Build Info: {name}-{version} ({releaseDate})
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
